import React from 'react';

function AppsByCategoryTagHeader({ tag, numberOfProjects, onSeeAllClick }) {

    function handleSeeAllClick() {
        onSeeAllClick({ templateName: tag });
    }

    return (
        <div className='row'>
            <div className='col-12 w-100 d-flex justify-content-between align-items-between mt-4'>
                <h4 className='font-size-2 font-weight'>
                    { tag }
                </h4>
                <div>
                    <button className='btn' onClick={handleSeeAllClick}>
                        See all / { numberOfProjects }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AppsByCategoryTagHeader;